// extracted by mini-css-extract-plugin
module.exports = {"container":"viewEdit_container__25g_E","table":"viewEdit_table__1uSwm","newRow":"viewEdit_newRow__yAdGn","newName":"viewEdit_newName__2k2zv","input":"viewEdit_input__1-m0D"};